module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-692d3b83"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/WxLogin.vue
// module id = 646
// module chunks = 25